import { useEffect, useState } from 'react';
import { Card, Col, Row } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { TradeReportServices } from '../../services/TradeReportServices';
import * as BullCache from "../../util/BullCache";
import { isMobile } from '../../util/GeneralUtil';
import AdminDropdown from '../components/AdminDropdown';
import BrokerDropdown from '../components/BrokerDropdown';
import ClientDropdown from '../components/ClientDropdown';
import { customStyles, the } from '../components/customStyles';
import From from '../components/From';
import MarketDropdown from '../components/MarketDropdown';
import MasterDropdown from '../components/MasterDropdown';
import ScriptDropdown from '../components/ScriptDropdown';
import SubBrokerDropdown from '../components/SubBrokerDropdown';
import To from '../components/To';

function Test() {

  const [selectedMarket, setSelectedMarket] = useState(null);
  const [selectedScript, setSelectedScript] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [valanDates, setValanDates] = useState([]);
  const [selectedValan, setSelectedValan] = useState('');
  const [selectedReportType, setSelectedReportType] = useState('POSITION'); // Step 1


  var user = BullCache.getFromCache("user");

  const navigate = useNavigate();


  var allScripts = BullCache.getFromCache('allScripts');
  const handleMarketChange = (market) => {
    setSelectedMarket(market);
  };

  const handleScriptChange = (script) => {
    setSelectedScript(script);
  };
  const handleScriptReset = () => {
    setSelectedScript(null);
  };
  const handleSelectedClientChange = (selected) => {
    setSelectedClient(selected?.userId);
  };
  const handleFromDateChange = (newDate) => {
    setFromDate(newDate);
  };
  const handleToDateChange = (newDate) => {
    setToDate(newDate);
  };
  const options = valanDates.map(valan => ({
    value: valan.valanId,
    label: valan.date
  }));

  useEffect(() => {
    TradeReportServices.valanDates().then(res => {
      if (res.code === 1) {
        if (res.data.valandates.length > 0) {
          setValanDates(res.data.valandates);
        }
      }
    });
  }, []);


  const handleValanDateChange = (selectedOption) => {
    setSelectedValan(selectedOption ? selectedOption.value : '');
  };

  const handleNavigate = () => {
    let idToPass = {};

    idToPass.adminId= user.adminId;
    if (selectedClient) {
      idToPass.userId = selectedClient;  // Pass SubBroker ID
      idToPass.adminId = user.adminId;
    }
    else if (selectedSubBrokerId) {
      idToPass.adminId = selectedSubBrokerId.value;  // Pass SubBroker ID
    } else if (selectedBrokerId) {
      idToPass.adminId = selectedBrokerId;  // Pass Broker ID
    } else if (selectedMaster) {
      idToPass.adminId = selectedMaster.value;  // Pass Master ID
    } else if (selectedAdmin) {
      idToPass.adminId = selectedAdmin.value;  // Pass Admin ID
    }

    if (idToPass) {
      navigate("/tradehodiyu", {
        state: idToPass  
      });
    }
     
  };
    
  const handleReportTypeChange = (event) => {
    setSelectedReportType(event.target.value);  
  };
  return (
    <div className="container-fluid">
      <Card className="mt-2 mb-5">
        <Card.Body>
          <Row className='mt-3'>
            <Col xl={1} className='me-3'>
              <b style={{ fontSize: 12 }} className='h6'> REPORT TYPE</b>
            </Col>
            <Col xl={6}>
              {['radio'].map((type) => (
                <div key={`inline-${type}`} className="mb-3">
                  <Form.Check
                    inline
                    style={{ fontSize: 12 }}
                    className='fw-bold'
                    label="POSITION"
                     value="POSITION"
                    name="1"
                    type={type}
                    id={`inline-${type}-1`}
                    checked={selectedReportType === 'POSITION'} // Ensure POSITION is selected by default
                    onChange={handleReportTypeChange}
                  />

                  {user.adminType === "SUPER_ADMIN" || user.adminType == 'SUPER_MASTER' ?
                    <Form.Check
                      inline
                      label="ADMIN PNL"
                      style={{ fontSize: 12 }}
                      className='fw-bold'
                      name='1'
                       value="ADMIN_PNL"
                      type={type}
                      id={`inline-${type}-3`}
                      checked={selectedReportType === 'ADMIN_PNL'} // Ensure POSITION is selected by default
                    onChange={handleReportTypeChange}
                    />
                    : ""}
                  {user.adminType === "SUPER_ADMIN" || user.adminType === "ADMIN" || user.adminType == 'SUPER_MASTER' ?

                    <Form.Check
                      inline
                      label="MASTER PNL"
                      style={{ fontSize: 12 }}
                      className='fw-bold'
                      name='1'
                       value="MASTER_PNL"
                      type={type}
                      id={`inline-${type}-3`}
                      checked={selectedReportType === 'MASTER_PNL'} // Ensure POSITION is selected by default
                    onChange={handleReportTypeChange}
                    />
                    : ""}
                  {user.adminType === "SUPER_ADMIN" || user.adminType === "ADMIN" || user.adminType === "MASTER" || user.adminType == 'SUPER_MASTER' ?

                    <Form.Check
                      inline
                      label="BROKER PNL"
                      style={{ fontSize: 12 }}
                      className='fw-bold'
                      name='1'
                       value="BROKER_PNL"
                      type={type}
                      id={`inline-${type}-3`}
                      checked={selectedReportType === 'BROKER_PNL'} // Ensure POSITION is selected by default
                    onChange={handleReportTypeChange}
                    />
                    : ""}
                  {user.adminType === "SUPER_ADMIN" || user.adminType === "ADMIN" || user.adminType === "MASTER" || user.adminType === "BROKER" 
                  || user.adminType == 'SUPER_MASTER' ?

                    <Form.Check
                      inline
                      label="SUBBROKER PNL"
                      style={{ fontSize: 12 }}
                      className='fw-bold'
                      name='1'
                       value="SUBBROKER_PNL"
                      type={type}
                      id={`inline-${type}-3`}
                      checked={selectedReportType === 'SUBBROKER_PNL'} // Ensure POSITION is selected by default
                    onChange={handleReportTypeChange}
                    />
                    : ""}
                  {user.adminType !== "CLIENT" ?

                    <Form.Check
                      inline
                      label="CLIENT PNL"
                      style={{ fontSize: 12 }}
                      className='fw-bold'
                      name="1"
                       value="CLIENT_PNL"
                      type={type}
                      id={`inline-${type}-2`}
                      checked={selectedReportType === 'CLIENT_PNL'} // Ensure POSITION is selected by default
                    onChange={handleReportTypeChange}
                    />
                    : ""}
                </div>
              ))}
            </Col>
          </Row>



          <Row className=''>
            <Col xl={1} className='me-3'>
              <b className='h6' style={{ fontSize: 12 }}>REPORT</b>
            </Col>
            <Col xl={4}>

              <Form.Select aria-label="Default select example" className='bg-light text-black form-select-sm'>
                <option>Hodiyu</option>
              </Form.Select>
            </Col>

            <Col sm={1} className='me-3'></Col>
            <Col  xl={4} sm={10}>
              <Row>
                <Col xs={6} xl={6} sm={5} className='mt-1' >
                  <b style={{ fontSize: 12 }} className='me-2'>FROM</b>
                  {isMobile ? <br />:""}
                  <From fromDate={fromDate} onDateChange={handleFromDateChange} />
                </Col>
                <Col xs={6} xl={6} sm={5} >
                  <b style={{ fontSize: 12 }} className=' me-2' >TO</b> 
                  {isMobile ? <br />:""}
                  <To toDate={toDate} setToDate={handleToDateChange} />
                </Col>

              </Row>
            </Col>



          </Row>

          <Row className='mt-3'>
            <Col xl={1} className='me-3'>
              <b className='h6' style={{ fontSize: 12 }}>VALAN</b>
            </Col>
            <Col xl={4}>

              <Select
                options={options}
                value={options.find(option => option.value === selectedValan)}
                onChange={handleValanDateChange}
                placeholder="Select"
                styles={customStyles}
                theme={the}
                isClearable
                className=" text-black"
              />
            </Col>
            <Col xl={1} className='me-3'>
              <b className='h6' style={{ fontSize: 12 }}>SEGMENT</b>
            </Col>
            <Col xl={4}>

              <MarketDropdown allScripts={allScripts} onMarketChange={handleMarketChange} onScriptReset={handleScriptReset} />
            </Col>


          </Row>

          <Row className='mt-3'>
          {(selectedReportType === 'ADMIN_PNL') && (
            <>
                <Col xl={1} className='me-3'>
                  <b className='h6' style={{ fontSize: 12 }}>ADMIN</b>
                </Col>
                <Col xl={4}>
                  <AdminDropdown
                    adminId={user.adminId}
                    setSelectedOption={setSelectedAdmin} />
                </Col>

              </>)}


            <Col xl={1} className='me-3'>
              <b className='h6' style={{ fontSize: 12 }}>SCRIPT</b>
            </Col>

            <Col xl={4}>
              <ScriptDropdown
                allScripts={allScripts}
                selectedMarket={selectedMarket}
                onScriptChange={handleScriptChange}
              />

            </Col>


          </Row>

     
              <Row className='mt-3'>
              {['ADMIN_PNL','MASTER_PNL'].includes(selectedReportType) && (
            <>
                <Col xl={1} className='me-3'>
                  <b className='h6' style={{ fontSize: 12 }}>MASTER</b>
                </Col>

                <Col xl={4}>
                <MasterDropdown
                        adminId={user.adminId}
                        selectedAdmin={selectedAdmin}
                        setSelectedOption={setSelectedMaster}
                        setSelectedMaster={setSelectedMaster}
                        setSelectedBrokerId={setSelectedBrokerId}

                      />
                </Col>
                </>)}
                {['ADMIN_PNL','MASTER_PNL','BROKER_PNL'].includes(selectedReportType) && (
            <>

                <Col xl={1} className='me-3'>
                  <b className='h6' style={{ fontSize: 12 }}>BROKER</b>
                </Col>
                <Col xl={4}>

                <BrokerDropdown
                  selectedAdmin={selectedAdmin}
                  selectedMaster={selectedMaster}
                  setSelectedOption={setSelectedBrokerId}
                  setSelectedBrokerId={setSelectedBrokerId}
                  setSelectedSubBrokerId={setSelectedSubBrokerId}
                />

                </Col>
</>)}

              </Row>

              <Row className='mt-3'>
              {['ADMIN_PNL','MASTER_PNL','BROKER_PNL','SUBBROKER_PNL'].includes(selectedReportType) && (
            <>

              <Col xl={1} className='me-3'>
                  <b className='h6' style={{ fontSize: 12 }}>SUB BROKER </b>
                </Col>
                <Col xl={4}>
              <SubBrokerDropdown
                    selectedAdmin={selectedAdmin}
                    selectedMaster={selectedMaster}
                    selectedBrokerId={selectedBrokerId}
                    setSelectedBrokerId={setSelectedBrokerId} // Pass setter function here
                    setSelectedSubBrokerId={setSelectedSubBrokerId}
                    setSelectedOption={setSelectedSubBrokerId}
                    setSelectedClientId={setSelectedClient}
                  />
                  </Col>
                  </>)}
                  {['ADMIN_PNL','MASTER_PNL','BROKER_PNL','SUBBROKER_PNL','CLIENT_PNL'].includes(selectedReportType) && (
            <>
                <Col xl={1} className='me-3'>
                  <b className='h6' style={{ fontSize: 12 }}>CUSTOMER </b>
                </Col>

                <Col xl={4}>
                <ClientDropdown
                    selectedAdmin={selectedAdmin}
                    selectedMaster={selectedMaster}
                    selectedBrokerId={selectedBrokerId}
                    selectedSubBrokerId={selectedSubBrokerId}
                    setSelectedOption={handleSelectedClientChange}
                  />

                </Col>
</>)}
              </Row>
         
          <Row className='mt-3'>

            <Col sm={6} className='text-center'>

              <Button variant="success" size='sm' onClick={handleNavigate}>View Report</Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  )
}
export default Test;
